// DO NOT EDIT -- generated from fs/services/webber/internal/impacts/impacts.proto

import * as alexa from '../../../alexa';
import * as funnels from '../../conversions';
import * as protobuf from '../../../../../google/protobuf';
import * as segment from '../../../../api/segment';

export namespace ImpactsPublic {

  export const GetImpactsTableConfigsEndpoint = "/grpc/impacts.ImpactsPublic/GetImpactsTableConfigs";
  /** Get all the impacts table configs. */
  export function GetImpactsTableConfigs(sender: (req: Request, endpoint: string) => Promise<ImpactsTableConfigs>, req: Request): { promise: () => Promise<ImpactsTableConfigs>, endpoint: string } {
    return {
      promise: () => sender(req, GetImpactsTableConfigsEndpoint),
      endpoint: GetImpactsTableConfigsEndpoint
    };
  }

  export const DeleteOpportunitySnapshotEndpoint = "/grpc/impacts.ImpactsPublic/DeleteOpportunitySnapshot";
  /** Delete the given OpportunitySnapshot by id. */
  export function DeleteOpportunitySnapshot(sender: (req: DeleteOpportunitySnapshotRequest, endpoint: string) => Promise<{}>, req: DeleteOpportunitySnapshotRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteOpportunitySnapshotEndpoint),
      endpoint: DeleteOpportunitySnapshotEndpoint
    };
  }

  export const GetOpportunitySnapshotShareLinksEndpoint = "/grpc/impacts.ImpactsPublic/GetOpportunitySnapshotShareLinks";
  /** Get shortlinks for snapshots */
  export function GetOpportunitySnapshotShareLinks(sender: (req: Request, endpoint: string) => Promise<SnapshotShareLinks>, req: Request): { promise: () => Promise<SnapshotShareLinks>, endpoint: string } {
    return {
      promise: () => sender(req, GetOpportunitySnapshotShareLinksEndpoint),
      endpoint: GetOpportunitySnapshotShareLinksEndpoint
    };
  }

  export const GetMutedOpportunityConfigsEndpoint = "/grpc/impacts.ImpactsPublic/GetMutedOpportunityConfigs";
  export function GetMutedOpportunityConfigs(sender: (req: GetMutedOpportunityConfigsRequest, endpoint: string) => Promise<GetMutedOpportunityConfigsResponse>, req: GetMutedOpportunityConfigsRequest): { promise: () => Promise<GetMutedOpportunityConfigsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetMutedOpportunityConfigsEndpoint),
      endpoint: GetMutedOpportunityConfigsEndpoint
    };
  }

  export const MuteOpportunityEndpoint = "/grpc/impacts.ImpactsPublic/MuteOpportunity";
  export function MuteOpportunity(sender: (req: MuteOpportunityRequest, endpoint: string) => Promise<MuteOpportunityResponse>, req: MuteOpportunityRequest): { promise: () => Promise<MuteOpportunityResponse>, endpoint: string } {
    return {
      promise: () => sender(req, MuteOpportunityEndpoint),
      endpoint: MuteOpportunityEndpoint
    };
  }

  export const UnmuteOpportunityEndpoint = "/grpc/impacts.ImpactsPublic/UnmuteOpportunity";
  export function UnmuteOpportunity(sender: (req: UnmuteOpportunityRequest, endpoint: string) => Promise<{}>, req: UnmuteOpportunityRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, UnmuteOpportunityEndpoint),
      endpoint: UnmuteOpportunityEndpoint
    };
  }
}

/**
 * A generic request that only needs org_id. Do not modify! If you need to add more
 * fields, copy and paste into a new request type, preserving field order.
 */
export interface Request {
  orgId: string;
}

export interface ImpactsTableConfigs {
  configs: ImpactsTableConfig[];
}

export interface ImpactsTableConfig {
  id: protobuf.int64;
  name: string;
  createdBy: string;
  createdAt: protobuf.timestamp | null;
  /** @deprecated */
  conversionId: protobuf.int64;
  segmentId: string;
  startTime: protobuf.timestamp | null;
  endTime: protobuf.timestamp | null;
  dateRangeId: string;
  customEvents: alexa.CustomEvent[];
  watchedElements: alexa.SeenEvent[];
  customQueries: CustomQueryProto[];
  starred: boolean;
  impactTypeFilters: alexa.ImpactType[];
  clickTypeFilters: alexa.BadClickType[];
  funnelId: string;
  updatedBy: string;
  updatedAt: protobuf.timestamp | null;
  definedEventIds: string[];
  /** whether or not to use funnel_id as a reference to a saved funnel or an unnamed funnel */
  unnamed: boolean;
  pageviewEvents: alexa.PageView[];
}

export interface CustomQueryProto {
  name: string;
  query: string;
}

export interface CustomEventsSerializer {
  customEvents: alexa.CustomEvent[];
}

export interface WatchedElementsSerializer {
  watchedElements: alexa.SeenEvent[];
}

export interface PageViewSerializer {
  pageViewEvents: alexa.PageView[];
}

export interface CreateOpportunitySnapshotRequest {
  orgId: string;
  label: string;
  steps: alexa.Step[];
  impactStats: alexa.ImpactStats | null;
  impactScope: alexa.ImpactScope;
  signal: alexa.Signal | null;
  timeRange: segment.TimeRange | null;
  impactTableConfigName: string;
  analysisMode: alexa.AnalysisMode;
  eventSequence: segment.EventSequence | null;
  segmentDefinition: segment.SegmentDefinition | null;
  segmentName: string;
  funnelName: string;
  isRevenueFunnel: boolean;
  revenueEvent: funnels.RevenueEvent | null;
  averageOrderValue: number;
}

export interface OpportunitySnapshot {
  orgId: string;
  id: string;
  createdAt: protobuf.timestamp | null;
  label: string;
  steps: alexa.Step[];
  impactStats: alexa.ImpactStats | null;
  impactScope: alexa.ImpactScope;
  signal: alexa.Signal | null;
  timeRange: segment.TimeRange | null;
  createdBy: string;
  origin: string;
  analysisMode: alexa.AnalysisMode;
  eventSequence: segment.EventSequence | null;
  segmentDefinition: segment.SegmentDefinition | null;
  segmentName: string;
  funnelName: string;
  isRevenueFunnel: boolean;
  revenueEvent: funnels.RevenueEvent | null;
  averageOrderValue: number;
}

/** A list of snapshots from calling GetOpportunitySnapshots */
export interface GetOpportunitySnapshotsResponse {
  snapshots: OpportunitySnapshot[];
}

export interface SnapshotShareLinkRequest {
  orgId: string;
  snapshotId: string;
}

export interface SnapshotShareLinkResponse {
  opportunitySnapshotId: protobuf.int64;
  id: protobuf.int64;
  shareLinkPath: string;
}

export interface DeleteOpportunitySnapshotRequest {
  orgId: string;
  id: string;
}

export interface SnapshotShareLinks {
  snapshotShareLinks: SnapshotShareLinkResponse[];
}

export interface MutedOpportunityConfig {
  id: string;
  analysisId: string;
  signalKey: string;
  signal: alexa.Signal | null;
  createdBy: string;
  createdAt: protobuf.timestamp | null;
}

export interface GetMutedOpportunityConfigsRequest {
  orgId: string;
  analysisId: string;
}

export interface GetMutedOpportunityConfigsResponse {
  mutedOpportunityConfigs: MutedOpportunityConfig[];
}

export interface MuteOpportunityResponse {
  mutedOpportunityConfig: MutedOpportunityConfig | null;
}

export interface MuteOpportunityRequest {
  orgId: string;
  analysisId: string;
  signal: alexa.Signal | null;
}

export interface UnmuteOpportunityRequest {
  orgId: string;
  analysisId: string;
  signal: alexa.Signal | null;
}
